module.exports = __webpack_public_path__ + "img/swap.99e48daf.png";